import CattlesLogo from 'assets/CattlesLogo'
import FeedTableIcon from 'assets/FeedTableIcon'
import GroupsIconLogo from 'assets/GroupsIconLogo'
import HealthIcon from 'assets/HealthIcon'
import LactationLogo from 'assets/LactationLogo'
import MilkCup from 'assets/MilkCup'
import { DOCK_CATEGORIES_TYPES } from '../../types/dockTypes'

export const DOCK_CATEGORIES = [
	{
		label: 'Все виджеты',
		icon: <GroupsIconLogo />,
		type: DOCK_CATEGORIES_TYPES.ALL,
	},
	{
		label: 'Поголовье',
		icon: <CattlesLogo />,
		type: DOCK_CATEGORIES_TYPES.CATTLES,
	},
	{
		label: 'Кормовой стол',
		icon: <FeedTableIcon />,
		type: DOCK_CATEGORIES_TYPES.FOOD_TABLE,
	},
	{
		label: 'Здоровье',
		icon: <HealthIcon />,
		type: DOCK_CATEGORIES_TYPES.HEALTH,
	},
	{
		label: 'Рутина доения',
		icon: <LactationLogo />,
		type: DOCK_CATEGORIES_TYPES.MILKING_PROCESS,
	},
	{ label: 'Надой', icon: <MilkCup />, type: DOCK_CATEGORIES_TYPES.MILK_YIELD },
]
